/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { Api } from '../axiosApi';

export interface IListagemNfeEntrada {
  idnfe: string;
  numero: string;
  chnfe: string;
  nome: string;
  fantasia: string;
  ie: string;
  cnpj: string;
  dhemi: string;
  tpnfe: number;
  valor: number;
  xjust: number;
  status: string;
}
export interface IDetalheNfeDist {
  idresnfe: string;
  chave: string;
  xjust: string;
  tpevento: string;
}
interface IDuplicatas {
  nDup: number;
  dVenc: string;
  vDup: number;
}
interface IDuplicatasGetById {
  dvenc: string;
  ndup: number;
  vdup: number;
}
export interface IitensMovimentoDialog {
  iditens: string;
  idprodutos: string;
  qtds: number;
  qtde: number;
  un: string;
  preco: number;
  ean?: string;
  ncm?: string;
  total: number;
  filtro: string;
  referencia?: string;
  marca?: string;
  descricao: string;
}
interface IParcelasFaturamento {
  idpagar: string;
  idplanoconta?: string | null;
  emissao: string;
  vencimento: string;
  numero: string;
  tipopagamento: string;
  tipo: number;
  parcela: string;
  vpagar: number;
  desconto: number;
  acrescimo: number;
  historico: string;
  vpago: number;
  vparcela: number;
  vcompra: number;
  qtdparcelas: number;
}
interface IDetalheMovimento {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  emissao: string;
  dataoperacao: string;
  numero: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
}
interface IgetEntradaNfe {
  idmov: string;
  idparceiro: string;
  idplanoconta: string;
  idoperacao: string;
  emissao: string;
  dataoperacao: string;
  numero: string;
  total: number;
  desconto: number;
  vprod: number;
  acrescimo: number;
  duplicatas: IDuplicatasGetById[];
  itens: IitensMovimentoDialog[];
}
export interface IRNFE {
  serie: number;
  nfe: number;
  dataemissao: Date;
  nome: string;
  fazenda: string;
  cpf: string;
  cfop: number;
  vnfe: number;
  finalidade: string;
  status: string;
}
type TotalCount = {
  data: IListagemNfeEntrada[];
  totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const getAll = async (
  page = 1,
  filter = '',
  limit = Environment.LIMITE_DE_LINHAS,
): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/nfedist?page=${page}&limit=${limit}&filter=${filter}`;
    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(
          headers['x-total-count'] || limit
        ),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
  if (axios.isAxiosError(error) && error.response) {
   const data = error.response.data as ErrorResponse;
    return new Error(
      data?.errors?.default || JSON.stringify(data)
    );
  }
  return error instanceof Error ? error : new Error(String(error));
}
};
const getById = async (id: string): Promise<IgetEntradaNfe | Error> => {
  try {
    const { data } = await Api.get(`/importnfe/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default;
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const createdistribuida = async (dados: IDetalheNfeDist): Promise<string | Error> => {
  try {
    const { data } = await Api.post<IDetalheNfeDist>('/manifestos', dados);
    return data.idresnfe || 'Registro criado com sucesso!';
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);

      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');

      } else {
        return new Error(axiosError.message);
      }
    }
    return new Error('Erro inesperado');
  }
};
const create = async (
  dados: IDetalheMovimento,
  dadositens: IitensMovimentoDialog[],
  faturamento: IParcelasFaturamento[]
): Promise<string | Error> => {
  try {

    const dadosExtraidos = dadositens.map(
      ({ descricao, filtro, referencia, ean, marca, ncm, ...rest }) => ({
        idmov: dados.idmov,
        tipo: 1,
        ...rest
      })
    );

    const pfaturamento = faturamento.map(
      ({ qtdparcelas,idplanoconta, ...rest }) => ({
        idmov: dados.idmov,
        idplanoconta: dados.idplanoconta,
        ...rest
      })
    );

    const dadosEntrada = { tipo: 1, xml: true, ...dados };

    await Api.post('/entradaporxml', [
      dadosEntrada,
      dadosExtraidos,
      pfaturamento,
    ]);

    return dados.idmov;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<unknown>;
      if (axiosError.response?.data) {
        if (typeof axiosError.response.data === 'string') {
          return new Error(axiosError.response.data);
        }
        return new Error(JSON.stringify(axiosError.response.data));
      }
      if (axiosError.request) {
        return new Error('Erro de comunicação com o servidor');
      }
      return new Error(axiosError.message);
    }
    if (error instanceof Error) {
      return error;
    }
    return new Error(String(error));
  }
};

const transmitir = async (id: string): Promise<Blob | Error> => {
  try {
    const response = await Api.put(
      `/transmitirnfe/${id}`,
      {}, 
      {
        responseType: 'blob', 
      }
    );
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response) {
      const blob = error.response.data as Blob;
      try {
        const text = await blob.text();
        const json = JSON.parse(text);
        const errorMessage = json?.error?.default || 'Erro desconhecido na resposta';
        return new Error(errorMessage);
      } catch (parseError) {
        try {
          const fallback = await (error.response.data as Blob).text();
          return new Error(fallback || 'Erro desconhecido ao interpretar erro');
        } catch {
          return new Error('Erro desconhecido ao ler blob');
        }
      }
    }
    if (axios.isAxiosError(error) && error.request) {
      return new Error('Nenhuma resposta do servidor');
    }
    if (axios.isAxiosError(error)) {
      return new Error(error.message);
    }
    return new Error('Erro inesperado');
  }
};
const Imprimir = async (id: string): Promise<Blob | Error> => {
  try {
    const { data } = await Api.get(`/geradanf/${id}`, {
      responseType: 'blob',
    });
    return data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const ServiceNfeEntrada = {
  getAll,
  create,
  getById,
  transmitir,
  createdistribuida,
  Imprimir,
};